import { useState, useCallback } from 'react'
export const useLoading = () => {
  const [isLoading, setIsLoading] = useState(false)

  const setLoading = useCallback((value: boolean) => {
    setIsLoading(value)
  }, [])

  return {
    isLoading,
    setLoading,
  }
}
